import React from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

import {ValidationResult, revalidate, required, limitedLength} from 'validation'
import {replacePlaceholders} from 'common/Replace';
import BaseComponent from 'common/BaseComponent';
import Input from 'common/Input';
import Select from 'common/Select';
import refreshIcon from 'theme/img/refresh.png';
import toggleDownIcon from './toggle_down.png';
import toggleUpIcon from './toggle_up.png';
import theme from '../../VpqClient.scss';
import conf from 'configuration.json'
import {getMessage as msg} from 'MessageBundle'
import ErrorBox from 'common/ErrorBox';

export default class MainTab extends BaseComponent {

    constructor(props) {
        super(props);
        this.types = new Map(this.props.complaintTypes.filter(t => t.active || (props.value.type === t.name)).map(t => [t.name, t.name]));

        this.state = {
            voInfoOpened: false,
            reasons: new Map(),
            causes: new Map(),
            products: new Map(),
            initReason: this.props.value.reason,
            initCause: this.props.value.cause,
            initProduct: this.props.value.product
        };
        this.initComplaintTypes(this.props);
    }

    componentWillReceiveProps(nextProps){
        if(!this.complaintTypeEquals(this.props.value, nextProps.value)) {
            this.initComplaintTypes(nextProps);
        }
    }

    complaintTypeEquals(a, b) {
        if(JSON.stringify(a.type) !== JSON.stringify(b.type)) {
            return false;
        }
        if(JSON.stringify(a.reason) !== JSON.stringify(b.reason)) {
            return false;
        }
        if(JSON.stringify(a.cause) !== JSON.stringify(b.cause)) {
            return false;
        }
        return JSON.stringify(a.product) === JSON.stringify(b.product);
    }

    initComplaintTypes(props) {
        const complaintType = props.complaintTypes.find(t => t.name === props.value.type);
        if (complaintType !== undefined) {
            const reason = complaintType.reasons.find(r => r.name === props.value.reason);
            this.state.reasons = new Map(complaintType.reasons.filter(r => r.active || (reason && reason.name === r.name)).map(r => [r.name, r.name]));
            if(reason !== undefined) {
                const cause = reason.causes.find(c => c.name === props.value.cause);
                this.state.causes = new Map(reason.causes.filter(c => c.active || (cause && cause.name === c.name)).map(c => [c.name, c.name]));
                if (cause !== undefined) {
                    const product = cause.products.find(p => p.name === props.value.product);
                    this.state.products = new Map(cause.products.filter(p => p.active || (product && product.name === p.name)).map(p => [p.name, p.name]));
                }
            }
        }
    }

    handleComplaintChange = (name, nestedName) => (event) => {
        // uvo property of complaint could be undefined.
        let oldProperty = this.props.value[name] || {};
        let change = update(oldProperty, {[nestedName]: {$set: event.target.value}});
        this.props.onElementChange(name)(change);
    };

    validation = {
        hvoReload: [
            {
                properties: ["props.value.hvo.vo"],
                individualNames: ["hvoVo"],
                strategies: [
                    required(msg('editComplaint.mainTab.validation.hvo.voRequired')),
                    limitedLength(5, 5, msg("editComplaint.mainTab.validation.hvo.voFormat"))
                ]
            }
        ],
        uvoReload: [
            {
                properties: ["props.value.uvo.vo"],
                individualNames: ["uvoVo"],
                strategies: [
                    limitedLength(5, 5, msg("editComplaint.mainTab.validation.uvo.voFormat"))
                ]
            }
        ]
    };

    handleVoReload = (field) => () => {
        const main = field === 'hvo';

        //if the UVO-ID field is empty then the data of this VO should be removed
        if (!main && (!this.props.value[field] || !this.props.value[field].vo)) {
            this.props.onElementChange(field)(undefined);
            const validationResult = new ValidationResult(this.props.errorMessages);
            validationResult.resetGroups(["uvoReload"]);
            return;
        }

        const errorGroup = main ? 'hvoReload' : 'uvoReload';
        const validationResult = revalidate(this, this.validation, [errorGroup], this.props.errorMessages);
        if (validationResult.isEmpty([errorGroup])) {
            this.props.onStart();
            const voValue = this.props.value[field] ? this.props.value[field].vo : "";
            const params = {
                vo: voValue,
                main: main
            };
            this.request('get', conf.rest.salesPartnerEndpoint).query(params).send((result) => {
                this.props.onElementChange(field)(result.body);
                this.props.onComplete();
            }, (error, result) => {
                let errorText;
                let invalidComponent;
                if (result && result.statusCode === 404) {
                    errorText = replacePlaceholders(msg('editComplaint.mainTab.validation.vo.voNotExists'), voValue);
                    invalidComponent = [main ? 'hvoVo' : 'uvoVo'];
                } else if (result && result.statusCode === 412) {
                    errorText = replacePlaceholders(main ? msg('editComplaint.mainTab.validation.vo.wrongHvo') :
                        msg('editComplaint.mainTab.validation.vo.wrongUvo'), voValue);
                    invalidComponent = [main ? 'hvoVo' : 'uvoVo'];
                } else {
                    errorText = msg("common.technicalError");
                    invalidComponent = [];
                }

                const validationResult = new ValidationResult(this.props.errorMessages);
                validationResult.setGroup(errorGroup, {[invalidComponent]: [errorText]});
                this.props.onError(validationResult.getErrorMessages());
                this.props.onComplete();
            });
        } else {
            this.props.onError(validationResult.getErrorMessages());
        }
    };

    getVoInfo = (hvo, uvo) => {
        return (
            <div className={theme.clear + ' ' + theme.extraWidth}>
                <div className={theme.coll}>
                    <div className={theme.row + ' ' + theme.extraWidthLabel}>
                        <Input id="hvoName1-txt" label={msg('editComplaint.mainTab.hvo.name1Label')} disabled={this.props.readOnly} value={hvo.name1}
                            onChange={this.handleComplaintChange('hvo', 'name1')}/>
                    </div>
                    <div className={theme.row + ' ' + theme.extraWidthLabel}>
                        <Input id="hvoName2-txt" label={msg('editComplaint.mainTab.hvo.name2Label')} value={hvo.name2} disabled={this.props.readOnly}
                            onChange={this.handleComplaintChange('hvo', 'name2')}/>
                    </div>

                    <div className={theme.row + ' ' + theme.rowMultiValue + ' ' + theme.extraWidthLabel}>
                        <div className={theme.rowLabelWrap}>
                            <label htmlFor="hvoStreet-txt">{msg('editComplaint.mainTab.hvo.streetLabel')}</label>
                            <label htmlFor="hvoHouseNumber-txt">{msg('editComplaint.mainTab.hvo.houseNumberLabel')}</label>
                        </div>
                        <input id="hvoStreet-txt" value={hvo.street} onChange={this.handleComplaintChange('hvo', 'street')}
                            className={theme.fieldStreet} disabled={this.props.readOnly} />
                        <input id="hvoHouseNumber-txt" value={hvo.houseNumber} onChange={this.handleComplaintChange('hvo', 'houseNumber')}
                            className={theme.fieldNum} disabled={this.props.readOnly} />
                    </div>
                    <div className={theme.row + ' ' + theme.rowMultiValue + ' ' + theme.extraWidthLabel}>
                        <div className={theme.rowLabelWrap}>
                            <label htmlFor="hvoZipCode-txt">{msg('editComplaint.mainTab.hvo.zipCodeLabel')}</label>
                            <label htmlFor="hvoCity-txt">{msg('editComplaint.mainTab.hvo.cityLabel')}</label>
                        </div>
                        <input id="hvoZipCode-txt" value={hvo.zipCode}
                            onChange={this.handleComplaintChange('hvo', 'zipCode')} className={theme.fieldZip} disabled={this.props.readOnly} />
                        <input id="hvoCity-txt" value={hvo.city}
                            onChange={this.handleComplaintChange('hvo', 'city')} className={theme.fieldLocation} disabled={this.props.readOnly} />
                    </div>

                    <div className={theme.row + ' ' + theme.extraWidthLabel}>
                        <Input id="hvoPoZipCode-txt" label={msg('editComplaint.mainTab.hvo.poZipCodeLabel')} value={hvo.poBoxZipCode}
                            onChange={this.handleComplaintChange('hvo', 'poBoxZipCode')} className={theme.fieldZip} disabled={this.props.readOnly}/>
                    </div>
                </div>
                <div className={theme.colr}>
                    <div className={theme.row + ' ' + theme.extraWidthLabel + ' ' + theme.rowFieldAlign}>
                        <Input id="uvoName1-txt" label={msg('editComplaint.mainTab.uvo.name1Label')} value={uvo.name1}
                            onChange={this.handleComplaintChange('uvo', 'name1')} disabled={this.props.readOnly}/>
                    </div>
                    <div className={theme.row + ' ' + theme.extraWidthLabel + ' ' + theme.rowFieldAlign}>
                        <Input id="uvoName2-txt" label={msg('editComplaint.mainTab.uvo.name2Label')} value={uvo.name2}
                            onChange={this.handleComplaintChange('uvo', 'name2')} disabled={this.props.readOnly}/>
                    </div>

                    <div className={theme.row + ' ' + theme.rowMultiValue + ' ' + theme.extraWidthLabel + ' ' + theme.rowFieldAlign}>
                        <div className={theme.rowLabelWrap}>
                            <label htmlFor="uvoStreet-txt">{msg('editComplaint.mainTab.uvo.streetLabel')}</label>
                            <label htmlFor="uvoHouseNumber-txt">{msg('editComplaint.mainTab.uvo.houseNumberLabel')}</label>
                        </div>
                        <input id="uvoStreet-txt" value={uvo.street}
                            onChange={this.handleComplaintChange('uvo', 'street')} className={theme.fieldStreet} disabled={this.props.readOnly}/>
                        <input id="uvoHouseNumber-txt" value={uvo.houseNumber}
                            onChange={this.handleComplaintChange('uvo', 'houseNumber')} className={theme.fieldNum} disabled={this.props.readOnly}/>
                    </div>
                    <div className={theme.row + ' ' + theme.rowMultiValue + ' ' + theme.extraWidthLabel + ' ' + theme.rowFieldAlign}>
                        <div className={theme.rowLabelWrap}>
                            <label htmlFor="uvoZipCode-txt">{msg('editComplaint.mainTab.uvo.zipCodeLabel')}</label>
                            <label htmlFor="uvoCity-txt">{msg('editComplaint.mainTab.uvo.cityLabel')}</label>
                        </div>
                        <input id="uvoZipCode-txt" value={uvo.zipCode}
                            onChange={this.handleComplaintChange('uvo', 'zipCode')} className={theme.fieldZip} disabled={this.props.readOnly}/>
                        <input id="uvoCity-txt" value={uvo.city}
                            onChange={this.handleComplaintChange('uvo', 'city')} className={theme.fieldLocation} disabled={this.props.readOnly}/>
                    </div>

                    <div className={theme.row + ' ' + theme.extraWidthLabel + ' ' + theme.rowFieldAlign}>
                        <Input id="uvoPoZipCode-txt" label={msg('editComplaint.mainTab.uvo.poZipCodeLabel')} value={uvo.poBoxZipCode}
                            onChange={this.handleComplaintChange('uvo', 'poBoxZipCode')} className={theme.fieldZip} disabled={this.props.readOnly}/>
                    </div>
                </div>
            </div>
        );
    };

    handleTypeChange = (e) => {
        const newTypeName = e.target.value;
        this.props.onChange({
            'type': newTypeName,
            'reason': '',
            'cause': '',
            'product': ''
        });

        const newType = this.props.complaintTypes.find(t => t.name === newTypeName);
        this.setState({
            reasons: new Map(newType ? newType.reasons.filter(r => r.active || (this.state.initReason && this.state.initReason === r.name))
                    .map(r => [r.name, r.name]) : []),
            causes: new Map(),
            products: new Map()
        });
    };

    handleReasonChange = (e) => {
        const newReasonName = e.target.value;
        this.props.onChange({
            'reason': newReasonName,
            'cause': '',
            'product': ''
        });

        const newReason = this.props.complaintTypes.find(t => t.name === this.props.value.type).reasons.find(r => r.name === newReasonName);
        this.setState({
            causes: new Map(newReason ? newReason.causes.filter(c => c.active || (this.state.initCause && this.state.initCause === c.name))
                    .map(c => [c.name, c.name]): []),
            products: new Map()
        })
    };

    handleCauseChange = (e) => {
        const newCauseName = e.target.value;
        this.props.onChange({
            'cause': newCauseName,
            'product': ''
        });

        const newCause = this.props.complaintTypes.find(t => t.name === this.props.value.type).reasons.find(r => r.name === this.props.value.reason).causes.find(c => c.name === newCauseName);
        this.setState({
            products: new Map(newCause ? newCause.products.filter(p => p.active || (this.state.initProduct && this.state.initProduct === p.name))
                    .map(p => [p.name, p.name]): [])
        })
    };

    render() {
        const {requestedAmountNet, type = "", reason = "", cause = "", product = "",
            debitNoteId = "",  externalReference = ""} = this.props.value;

        const complaintHvo = this.props.value.hvo;
        const hvo = {
            vo: complaintHvo.vo || "",
            name1: complaintHvo.name1 || "",
            name2: complaintHvo.name2 || "",
            street: complaintHvo.street || "",
            houseNumber: complaintHvo.houseNumber || "",
            zipCode: complaintHvo.zipCode || "",
            city: complaintHvo.city || "",
            poBoxZipCode: complaintHvo.poBoxZipCode || ""
        };
        const complaintUvo = this.props.value.uvo || {};
        const uvo = {
            vo: complaintUvo.vo || "",
            name1: complaintUvo.name1 || "",
            name2: complaintUvo.name2 || "",
            street: complaintUvo.street || "",
            houseNumber: complaintUvo.houseNumber || "",
            zipCode: complaintUvo.zipCode || "",
            city: complaintUvo.city || "",
            poBoxZipCode: complaintUvo.poBoxZipCode || ""
        };
        return (
            <div>
                <div className={theme.clear + ' ' + theme.extraWidth}>
                    <div className={theme.coll}>
                        <div className={theme.row + ' ' + theme.rowHUId + ' ' + theme.extraWidthLabel}>
                            <Input id="hvo-txt" value={hvo.vo} name="hvoVo" errorMessages={this.props.errorMessages}
                                onChange={this.handleComplaintChange('hvo', 'vo')} required label={msg('editComplaint.mainTab.hvo.voLabel')}
                                disabled={this.props.readOnly}/>
                            <button onClick={this.handleVoReload('hvo')} disabled={this.props.readOnly} title={msg('editComplaint.mainTab.reloadHvoText')}>
                                <img src={refreshIcon} alt={msg('editComplaint.mainTab.reloadHvoText')}/>
                            </button>
                        </div>
                        <div className={theme.row + ' ' + theme.extraWidthLabel}>
                            <Input id="hvoName-txt" value={hvo.name1 + " " + hvo.name2} name="hvoName" errorMessages={this.props.errorMessages}
                                required label={msg('editComplaint.mainTab.hvo.nameLabel')} disabled/>
                        </div>
                    </div>
                    <div className={theme.colr}>
                        <div className={theme.row + ' ' + theme.rowHUId + ' ' + theme.extraWidthLabel + ' ' + theme.rowFieldAlign}>
                            <Input id="uvo-txt" name="uvoVo" label={msg('editComplaint.mainTab.uvo.voLabel')} value={uvo.vo}
                                errorMessages={this.props.errorMessages} onChange={this.handleComplaintChange('uvo', 'vo')}
                                disabled={this.props.readOnly}/>
                            <button onClick={this.handleVoReload('uvo')} disabled={this.props.readOnly} title={msg('editComplaint.mainTab.reloadUvoText')}>
                                <img src={refreshIcon} alt={msg('editComplaint.mainTab.reloadUvoText')}/>
                            </button>
                        </div>
                        <div className={theme.row + ' ' + theme.rowName + ' ' + theme.extraWidthLabel + ' ' + theme.rowFieldAlign}>
                            <Input id="uvoName-txt" label={msg('editComplaint.mainTab.uvo.nameLabel')} disabled
                                value={uvo.name1 + " " + uvo.name2}/>

                            <a onClick={() => {this.setState({voInfoOpened: !this.state.voInfoOpened})}} href="javascript:void(0)"
                                className={theme.switch} title={this.state.voInfoOpened ? msg('editComplaint.mainTab.hideVoDetails') : msg('editComplaint.mainTab.showVoDetails')}>
                                <img src={this.state.voInfoOpened ? toggleUpIcon : toggleDownIcon} alt=""/>
                            </a>
                        </div>
                    </div>
                </div>

                {this.state.voInfoOpened ? this.getVoInfo(hvo, uvo) : null}

                <div className={theme.clear + ' ' + theme.extraWidth + ' ' + theme.rowDecor}>
                    <div className={theme.coll}>
                        <div className={theme.row + ' ' + theme.extraWidthLabel}>
                            <Select id="type-select" value={type} options={this.types} name="type" errorMessages={this.props.errorMessages}
                                onChange={this.handleTypeChange} required label={msg('editComplaint.mainTab.typeLabel')} disabled={this.props.readOnly}/>
                        </div>
                        <div className={theme.row + ' ' + theme.extraWidthLabel}>
                            <Select id="reason-select" value={reason} options={this.state.reasons} name="reason" errorMessages={this.props.errorMessages}
                                onChange={this.handleReasonChange} required label={msg('editComplaint.mainTab.reasonLabel')} disabled={this.props.readOnly}/>
                        </div>
                        <div className={theme.row + ' ' + theme.extraWidthLabel}>
                            <Select id="cause-select" value={cause} options={this.state.causes} name="cause" errorMessages={this.props.errorMessages}
                                onChange={this.handleCauseChange} required label={msg('editComplaint.mainTab.causeLabel')} disabled={this.props.readOnly}/>
                        </div>
                        <div className={theme.row + ' ' + theme.extraWidthLabel}>
                            <Select id="product-select" value={product} options={this.state.products} name="product" errorMessages={this.props.errorMessages}
                                onChange={this.props.onElementChange('product')} required label={msg('editComplaint.mainTab.productLabel')} disabled={this.props.readOnly}/>
                        </div>
                    </div>
                    <div className={theme.colr}>
                        <div className={theme.row}>
                            <Input id="debitNoteId-txt" label={msg('editComplaint.mainTab.debitNoteIdLabel')}
                                value={debitNoteId} onChange={this.props.onElementChange('debitNoteId')}
                                disabled={this.props.readOnly}/>
                        </div>
                        <div className={theme.row}>
                            <Input id="externalReference-txt" label={msg('editComplaint.mainTab.externalReferenceLabel')}
                                fullLabel={msg('editComplaint.mainTab.externalReferenceLabel.full')}
                                value={externalReference} onChange={this.props.onElementChange('externalReference')}
                                disabled={this.props.readOnly}/>
                        </div>
                        <div className={theme.row}>
                            <Input id="requestedAmountNet-txt" label={msg('editComplaint.mainTab.requestedAmountNetLabel')}
                                value={requestedAmountNet} onChange={this.props.onElementChange('requestedAmountNet')}
                                disabled={this.props.readOnly} allowedSymbols={"^[0-9.,]$"}/>
                        </div>
                        <div className={theme.row}>
                            <Input id="approvedAmountNet-txt" value={this.props.approvedAmountNet} name="approvedAmountNet" errorMessages={this.props.errorMessages}
                                 label={msg('editComplaint.mainTab.approvedAmountNetLabel')} required disabled/>
                        </div>
                        <div className={theme.row}>
                            <Input id="approvedAmountTotal-txt" value={this.props.approvedAmountTotal} name="approvedAmountTotal" errorMessages={this.props.errorMessages}
                                label={msg('editComplaint.mainTab.approvedAmountTotalLabel')} required disabled/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

MainTab.propTypes = {

    /**
     * Filled mainTab part of complaint object
     */
    value: PropTypes.object.isRequired,

    /**
     * Map of the available complaint types.
     */
    complaintTypes: PropTypes.array.isRequired,

    /**
     * Function, used to change values in parent state.
     */
    onChange: PropTypes.func.isRequired,

    /**
     * Function, called in case error is happened.
     */
    onError: PropTypes.func.isRequired,

    /**
     * Function, used to change mainTab elements value in parent state.
     */
    onElementChange: PropTypes.func.isRequired,

    /**
     * Array of error messages to be shown on the tab.
     */
    errorMessage: PropTypes.array,

    /**
     *  Flag, showing complaint is editable or not.
     */
    readOnly: PropTypes.bool,

    /**
     * Approved amount net value.
     */
    approvedAmountNet: PropTypes.string,

    /**
     * Approved amount total value.
     */
    approvedAmountTotal: PropTypes.string,
};

MainTab.defaultProps = {
    approvedAmountNet: "0",
    approvedAmountTotal: "0",
};


// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/EditComplaint/MainTab/index.js